/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { DefaultTheme } from 'styled-components/native'

import { BannerType } from 'ui/designSystem/Banner/enums'

export const getBannerColors = (theme: DefaultTheme, type: BannerType) => {
  switch (type) {
    case BannerType.SUCCESS:
      return {
        background: theme.designSystem.color.background.success,
        iconColor: theme.designSystem.color.icon.success,
      }
    case BannerType.ALERT:
      return {
        background: theme.designSystem.color.background.warning,
        iconColor: theme.designSystem.color.icon.warning,
      }
    case BannerType.ERROR:
      return {
        background: theme.designSystem.color.background.error,
        iconColor: theme.designSystem.color.icon.error,
      }
    default:
      return {
        background: theme.designSystem.color.background.info,
        iconColor: theme.designSystem.color.icon.info,
      }
  }
}
